import React from 'react'
import { Button } from 'hhsoig-design-system-core'
import { Divider } from '../../../../components/divider'
import { withDocTitle } from '../../../../components/withDocTitle'
import { ShareFeedback } from '../../../confirmation'

export const IHSconfirmation = ({ showFeedback }) => (
  <main data-testid="complaint-confirmation">
    <h1>Confirmation</h1>
    <p>You have successfully submitted your complaint.</p>
    <p>
      Your report is very valuable to us for the enforcement of the IHS zero
      tolerance of sexual abuse or child exploitation. Every report we receive
      is evaluated for investigation by the Office of Inspector General (OIG).
      The OIG provides health care law enforcement by conducting criminal, civil
      and administrative investigations for internal IHS programs. When
      evaluating a complaint, OIG considers whether the information provided is
      sufficient to indicate a violation of law has occurred, and whether it is
      feasible to further investigate.
    </p>
    <p>
      If you have identified yourself, a reviewing official may contact you for
      further information. However, it is important to note that you may not be
      contacted by an investigator even if your complaint is being investigated.
      Beyond this confirmation notice, the Hotline will not be able to confirm
      receipt of your complaint or respond to any inquiries about action taken
      on your complaint.
    </p>
    <p>
      You may request information about your complaint through the
      {` `}
      <a href="https://oig.hhs.gov/foia">OIG Freedom of Information Act</a>
      {` `}
      office. Remember to phrase your request in terms of a search for records
      pertinent to your complaint, not status. You should wait at least six
      months before filing such a request.
    </p>
    <Button
      variation="secondary"
      data-testid="confirm-complaint"
      href="https://oig.hhs.gov/fraud/report-fraud/index.asp"
      className="ds-u-margin-top--3"
    >
      Return to HHS-OIG Hotline
    </Button>
    {showFeedback && (
      <React.Fragment>
        <Divider />
        <ShareFeedback />
      </React.Fragment>
    )}
  </main>
)

export default withDocTitle(IHSconfirmation)
